import { MODAL_PRIORITY, type QueuedModalDescriptor } from '@heidi/dictate';
import { ModalId } from '@heidi/schema/ml-scribe';

export const USB_DICTAPHONE_SETUP_CARD_MODAL_ID =
  ModalId.ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_POPOVER;

// Phase 2 (device setup offered) tracks seen-state under its own id, so users
// who saw the phase-1 card are offered setup once more.
export const USB_DICTAPHONE_SETUP_CARD_V2_MODAL_ID =
  ModalId.ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_V2_POPOVER;

// Once per user per phase via seen_modals. A later connect, including a different device, does not re-show.
export const USB_DICTAPHONE_SETUP_CARD_QUEUE_ITEM: QueuedModalDescriptor = {
  id: USB_DICTAPHONE_SETUP_CARD_MODAL_ID,
  priority: MODAL_PRIORITY.HIGH,
  dismissible: true,
  showOnce: true,
};

export const USB_DICTAPHONE_SETUP_CARD_V2_QUEUE_ITEM: QueuedModalDescriptor = {
  ...USB_DICTAPHONE_SETUP_CARD_QUEUE_ITEM,
  id: USB_DICTAPHONE_SETUP_CARD_V2_MODAL_ID,
};
